/**
 * Created by Michał Stawski on 2017-12-27.
 */

import { Button, Paper, Typography, withStyles } from '@material-ui/core'
import * as React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { TextField } from 'redux-form-material-ui-adapter'
import { reLogin, sendLogin } from '../reducers/authorization'
import { Redirect } from 'react-router-dom'

const styles = theme => ({
  root:
    {
      padding: theme.spacing.unit * 6,
      margin: 'auto',
      float: 'left',
      position: ' absolute',
      top: '50%',
      transform: 'translateY(-50%) translateX(-50%)',
      left: '50%',
      textAlign: 'center',

    }
  ,
  textField: {
    display: 'flex'

  },
  button: {
    width: '100%'
  },
  buttonRequest: {
    width: '100%'
  },
  error: {
    color: 'red'
  },
  logoImage: {
    maxWidth: 200,
    margin: 50,
    marginBottom: 50 + theme.spacing.unit * 4
  }
})

class Login extends React.Component {
  componentDidMount () {
    this.props.reLogin(this.props.authorization)
  }

  render () {
    let {
      classes, sendLogin, formState, initialized, authorization, requestReset,
      handleSubmit,
      ...props
    } = this.props
    // let values
    // if (!formState || formState.values === undefined) {
    //   values = props.initialValues
    // } else {
    //   values = formState.values
    // }
    const { from } = (props.location && props.location.state) || { from: { pathname: '/' } }
    // const {redirectToReferrer} = this.state;

    if (authorization.loggedIn) {
      return (
        <Redirect to={from}/>
      )
    }
    return (
      authorization.loggedIn ? <div></div> :
        <Paper className={classes.root}>
          {/*<img alt="logo" src="/static/HP_fullcolorset900.png" className={classes.logoImage}/>*/}
          <Typography variant="h5" component="h1">
            Logowanie:
          </Typography>
          <form onSubmit={handleSubmit}>
            <Field
              required
              id="required"
              label="Nazwa Użytkownika:"
              className={classes.textField}
              margin="normal"
              component={TextField}
              name="username"
            />
            <Field
              id="password"
              label="Hasło:"
              className={classes.textField}
              type="password"
              autoComplete="current-password"
              margin="normal"
              name="password"
              component={TextField}
            />
            {authorization.error ?
              <Typography className={classes.error}>Błąd logowania</Typography>
              : ''}
            <Button variant="contained" color="primary"
                    type="submit"
                    disabled={!initialized || !formState.values.username || !formState.values.password}
                    className={classes.button} onClick={() => handleSubmit()}>
              Zaloguj
            </Button>
            <Button
              className={classes.buttonRequest} onClick={() => {
              requestReset()
            }}>
              Odzyskaj hasło
            </Button>
          </form>
          {/*<Tooltip title="Skontaktuj się z administratorem" className={classes.buttonRequest}>*/}
          {/*<div>*/}
          {/*<Button disabled*/}
          {/*onClick={() => {*/}
          {/*}}>*/}
          {/*Request access*/}
          {/*</Button>*/}
          {/*</div>*/}
          {/*</Tooltip>*/}
        </Paper>
    )
  }
}

let LoginScreen = withStyles(styles)(connect(
  (state) => {
    return {
      formState: state.form.loginForm,
      authorization: state.authorization
    }
  },
  (dispatch) => ({
    reLogin: reLogin(dispatch),
    requestReset: () => {
      const wl = window.location
      const origin = wl.protocol + '//' + wl.host
      window.open(origin + '/user/password/reset/', '_blank')

    }
  })
)(reduxForm({
  form: 'loginForm', initialValues: { username: null, password: null },
  onSubmit: sendLogin
})(Login)))

export default LoginScreen
